// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"d840a6ee932cac713279","589":"2db30894c3251ee11c0c","691":"b0a5ed92ca5ac3e5413a"}[chunkId] + ".js";
};